module.exports = __webpack_public_path__ + "img/file7.dd073ebd.png";